import { GetterTree } from 'vuex';
import { ContentModel, ContentInfo } from '@descomplica/dex-models';
import { ContentState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<ContentState, RootState> = {
  contentById: (state, contentsGetters) => (contentId: number) => {
    const content = state.contents[contentId.toString()];

    return content ? new ContentModel(content, contentsGetters) : undefined;
  },
  contentsByArticleId: (state, contentsGetters) => (articleId: number) => {
    return Object.values(state.contents)
      .map((content: ContentInfo) => new ContentModel(content, contentsGetters))
      .filter((content) => content.articleId === articleId);
  },
  contentsByQuestionId: (state, contentsGetters) => (questionId: number) => {
    return Object.values(state.contents)
      .map((content: ContentInfo) => new ContentModel(content, contentsGetters))
      .filter((content) => content.questionId === questionId);
  },
  contentsByAssertionId: (state, contentsGetters) => (assertionId: number) => {
    return Object.values(state.contents)
      .map((content: ContentInfo) => new ContentModel(content, contentsGetters))
      .filter((content) => content.assertionId === assertionId);
  },
  contentsBySolutionId: (state, contentsGetters) => (solutionId: number) => {
    return Object.values(state.contents)
      .map((content: ContentInfo) => new ContentModel(content, contentsGetters))
      .filter((content) => content.solutionId === solutionId)
      .sort((a, b) => a.position - b.position);
  },
  contentsByCommentId: (state, contentsGetters) => (commentId: number) => {
    return Object.values(state.contents)
      .map((content: ContentInfo) => new ContentModel(content, contentsGetters))
      .filter((content) => content.commentId === commentId);
  },
};

export default getters;
